<!--
 * @Descripttion: 
 * @Author: Junteng Shi
 * @Date: 2023-06-20 16:27:48
 * @LastEditors: Junteng Shi
 * @LastEditTime: 2024-08-27 11:24:44
-->
<template>
  <svg aria-hidden="true" class="svg-icon-spin" :class="calsses" :style="{ color: props.color || undefined }">
    <use :xlink:href="symbolId" />
  </svg>
</template>

<script lang="ts" setup>
  const props = withDefaults(
    defineProps<{
      prefix?: string;
      name: string;
      size?: 'default' | 'small' | 'large' | `custom-${string}px`;
      color?: string; // 新增 color 属性
    }>(),
    {
      prefix: 'icon',
      size: 'default',
    },
  );
  const symbolId = computed(() => `#${props.prefix}-${props.name}`);
  const calsses = computed(() => {
    if (props.size.includes('custom')) {
      return {
        'sdms-size-custom': props.size.split('-')[1],
      };
    }
    return {
      [`sdms-size-${props.size}`]: props.size,
    };
  });
  const fontSize = reactive({
    default: '20px',
    small: '16px',
    large: '32px',
    custom: props.size.split('-')[1],
  });
</script>
<style lang="less" scoped>
  .svg-icon-spin {
    width: v-bind('fontSize.default');
    height: v-bind('fontSize.default');
    fill: currentColor; // 这里 currentColor 就是 svg 的 color
    vertical-align: middle;

    &.sdms-size-small {
      font-size: v-bind('fontSize.small');
      width: v-bind('fontSize.small');
      height: v-bind('fontSize.small');
    }

    &.sdms-size-large {
      font-size: v-bind('fontSize.large');
      width: v-bind('fontSize.large');
      height: v-bind('fontSize.large');
    }

    &.sdms-size-custom {
      font-size: v-bind('fontSize.custom');
      width: v-bind('fontSize.custom');
      height: v-bind('fontSize.custom');
    }
  }
</style>
